// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-E":"E_amazon-sale-E__OUXRu"};